import React from 'react';
import { Redirect } from 'react-router-dom';
import { useDecision } from '@walmart-dataventures/feature-flag-sdk-react';
import { logger } from '../../utils/logger';

const withFeatureEnabled = (
  WrappedComponent: React.ComponentType,
  featureName: string
) => {
  return (props: any) => {
    const [decision, clientReady] = useDecision(featureName);

    if (decision.enabled) return <WrappedComponent {...props} />;

    if (!clientReady) return null;

    // decision.enabled is false and clientReady is true, redirect user to /
    logger.info('Feature is disabled, redirecting to /', {
      featureName,
      currentPath: window.location.pathname
    });
    return <Redirect to="/" />;
  };
};

export default withFeatureEnabled;
